<div class="weight__control__card">
  <div class="row-between-center mb-4">
    @if (tagText) {
      <h3 class="rounded-lg px-3 py-1 font-semibold" [ngClass]="tagClass">{{ tagText }}</h3>
    }
    <div class="row-sm">
      @if (isWeightSaved()) {
        <p-button icon="pi pi-refresh" label="Reset" severity="secondary" (onClick)="onResetWeight()" [outlined]="true" *ngIf="!disabled" />
        @if (canPrint()) {
          <p-button icon="pi pi-print" label="Print" severity="info" (onClick)="onPrintWeight()" [outlined]="true" />
        }
      }
      <p-button
        icon="pi pi-check"
        label="Save"
        [disabled]="disabled || isWeightSaved() || !isWeightValid()"
        (onClick)="onSaveWeight()"
        [severity]="isWeightSaved() ? 'success' : 'primary'"
      />
    </div>
  </div>

  <div
    class="weight__feedback"
    [ngClass]="{
      weight__stable: scaleData?.status === 'STABLE' && !isWeightSaved(),
      weight__unstable: scaleData && scaleData.status !== 'STABLE' && !isWeightSaved(),
      weight__default: !scaleData && !isWeightSaved(),
      weight__saved: isWeightSaved(),
    }"
  >
    <div class="mb-4" *ngIf="!disabled && !isWeightSaved()">
      <label class="row-sm-start-center">
        <input type="checkbox" [(ngModel)]="manualWeightOverride" />
        <span class="font-semibold text-lg">
          {{ 'weightStationDetails_enterWeightManually' | translateWF: 'Enter Weight Manually' }}
        </span>
      </label>
    </div>

    @if (isWeightSaved()) {
      <div class="weight__info text-xl font-medium">
        {{ title }}
        <span class="block text-3xl font-bold text-green-600">{{ getDisplayWeight() }} Lbs</span>
        <small class="text-sm text-gray-600"> Saved {{ savedWeight?.isManual ? 'manually' : 'from scale' }} at {{ savedWeight?.timestamp | date: 'short' }} </small>
      </div>
    } @else {
      @if (!manualWeightOverride) {
        <ng-container *ngIf="scaleData; else noData">
          <div class="weight__info text-xl font-medium">
            {{ title }}
            <span class="block text-3xl font-bold">{{ scaleData.weight }} {{ scaleData.unit }}</span>
          </div>
          <div class="weight__status text-lg">{{ 'weightStationDetails_status' | translateWF: 'Status' }}: {{ scaleData.status }}</div>
        </ng-container>

        <ng-template #noData>
          <div class="weight__info text-xl font-medium">
            {{ title }}
            <span class="block text-3xl font-bold">0 Lbs</span>
          </div>
        </ng-template>
      } @else {
        <!-- Manual input shown when toggle is active -->
        <div class="col-start-start gap-2">
          <label for="manualWeight" class="text-xl font-medium">
            {{ 'weightStationDetails_enterWeight' | translateWF: 'Enter Weight (Lbs)' }}
          </label>

          @if (initialWeight > 0) {
            <small class="text-sm text-orange-600 font-semibold"> Maximum allowed: {{ initialWeight }} lbs (original weight) </small>
          }
          @if (minWeight > 0) {
            <small class="text-sm text-orange-600 font-semibold"> Minimum required: {{ minWeight }} lbs (original weight) </small>
          }

          <input
            [(ngModel)]="manualWeightValue"
            type="number"
            id="manualWeight"
            [max]="initialWeight > 0 ? initialWeight : null"
            [min]="minWeight > 0 ? minWeight : null"
            class="p-4 text-3xl w-full max-w-sm rounded-lg border border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
            [class.border-red-500]="
              (manualWeightValue > 0 && initialWeight > 0 && manualWeightValue > initialWeight) || (minWeight > 0 && manualWeightValue > 0 && manualWeightValue < minWeight)
            "
            placeholder="{{ 'weightStationDetails_enterWeightPlaceholder' | translateWF: 'Enter weight manually' }}"
          />

          @if (manualWeightValue > 0 && initialWeight > 0 && manualWeightValue > initialWeight) {
            <div class="text-red-600 font-semibold text-sm bg-red-50 p-2 rounded">Weight {{ manualWeightValue }} lbs exceeds maximum of {{ initialWeight }} lbs</div>
          }
          @if (minWeight > 0 && manualWeightValue > 0 && manualWeightValue < minWeight) {
            <div class="text-red-600 font-semibold text-sm bg-red-50 p-2 rounded">Weight {{ manualWeightValue }} lbs is below the minimum of {{ minWeight }} lbs</div>
          }
        </div>
      }
    }
  </div>
  <p class="mt-2 text-sm text-gray-600">
    {{ 'weightStationDetails_weightControl' | translateWF: 'Weight control' }}
  </p>
</div>
